import React from 'react';

const ConfirmBox = ({ className, children, proceedText, cancelText, onProceed, onCancel }) => {
    return (
        <div className={`confirm-box box--${className}`}>
            <div className='confirm-box__content'>
                {children}
                <div className='confirm-box__actions'>
                    <button className='button' onClick={onProceed}>{proceedText}</button>
                    <button className='button button--link' onClick={onCancel}>{cancelText}</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmBox;
